import { render, staticRenderFns } from "./BsiCouponListItem.vue?vue&type=template&id=5035758e&scoped=true"
import script from "./BsiCouponListItem.vue?vue&type=script&lang=js"
export * from "./BsiCouponListItem.vue?vue&type=script&lang=js"
import style0 from "./BsiCouponListItem.vue?vue&type=style&index=0&id=5035758e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5035758e",
  null
  
)

export default component.exports